// extracted by mini-css-extract-plugin
export default {"background":"blog_background__CDG4q","container":"blog_container__-PB6p","content":"blog_content__UrXOn","buttonContainer":"blog_buttonContainer__0AhpK"};